<template>
  <div>
    <CommonVariationView
      type="amendment"
      reporter="contractor"
      :contract="contract"
      :items="items"
      @FETCH_DATA="handleFetchData"
      :form-fields="formFields"
    />
  </div>
</template>

<script>
import { getVariationsForContract } from '../services'
export default {
  name: 'AmendmentsView',
  props: {
    contract: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      items: [],
      formFields: ['milestoneButton', 'unlock', 'finalize']
    }
  },
  mounted () {
    if (this.contract && this.contract.id) {
      this.handleFetchData(this.contract.id)
    }
  },
  methods: {
    async handleFetchData () {
      this.items = await getVariationsForContract(this.contract.id, 'amendment')
    }
  },
  watch: {
    contract () {
      this.handleFetchData()
    }
  }
}
</script>
